<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ saveType == 'create' ? 'Create New' : 'Update' }} Action</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Name*"
                      v-model="name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Description*"
                      v-model="description"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Label*"
                      v-model="label"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-switch
                      v-model="hasDueDate"
                      :label="hasDueDate ? 'Action due date enabled' : 'Action due date disabled'"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="saveNewAction">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
  import LoadingOverlay from "../common/LoadingOverlay.vue";

export default {
  name: "ActionModal",
  props: {
    dialog: Boolean,
    editItem: Object,
    saveType: String,
  },
  components: {
    LoadingOverlay
  },
  data() {
    return {
      loading: false,
      name: "",
      description: "",
      label: "",
      showSuccess: false,
      hasDueDate: false
    };
  },
  methods: {
    ...mapActions(["createAction", "fetchActions", "updateAction"]),
    async saveNewAction() {
      this.loading = true;
      let body = {
        name: this.name,
        description: this.description,
        label: this.label,
        hasDueDate: this.hasDueDate
      };

      let save;
      if(this.saveType == 'create') {
        save = await this.createAction(body);
      } else {
        body.id = this.editItem.id;
        save = await this.updateAction(body);
      }
      
      if(save) {
        this.loading = false;
        console.log('show save type: ', this.saveType);
        this.$emit('showMessage', true);
        // this.showSuccess = true;
        this.close();
      }else{
        this.loading = false;
      }
      this.hasDueDate = false;
    },
    close() {
      this.name = '';
      this.description = '';
      this.label = '';
      this.hasDueDate = '';
      this.$emit('closeDialog', false);
    }
  },
  computed: mapGetters["allActions"],
  watch: {
    dialog: function () {
      if(this.dialog) {
        if(this.saveType == 'update') {
          this.name = this.editItem.name;
          this.description = this.editItem.description;
          this.label = this.editItem.label;
          this.hasDueDate = this.editItem.hasDueDate;
        }
      }
    }
  }
};
</script>

<style>
</style>